class SortIngredients extends HTMLElement {
  constructor() {
    super();

    this.ingredients = this.querySelectorAll("[data-name][data-alpha]");

    this.popin_container = document.querySelector(".popin-container");
    this.popin = document.querySelector(".sort-ingredients__popin");
    this.template_popin = this.popin.innerHTML;

    this.ingredients.forEach((ingredient) => {
      ingredient.addEventListener("click", this.openPopin.bind(this));
    });
  }

  openPopin(e) {
    document.querySelectorAll(".benefits h3").forEach((el) => {
      el.closest(".benefits").classList.remove("hidden");
    });
    let json = {};
    for (const ingredient of ingredients_json) {
      console.log(ingredient.name, e.currentTarget.dataset.name);
      if (ingredient.name == e.currentTarget.dataset.name) {
        json = ingredient;
        break;
      }
    }

    this.popin.innerHTML = this.template_popin
      .replace(/{title}/g, json.title)
      .replace(/{description}/g, json.description)
      .replace(/{separator}/g, json.separator_text)
      .replace(/{benefits1_title}/g, json.benefit_1_title)
      .replace(/{benefits1_description}/g, json.benefit_1_description)
      .replace(/{benefits1_link1}/g, json.benefit_1_link1 || "#")
      .replace(/{benefits1_link1_text}/g, json.benefit_1_link1_text)
      .replace(/{benefits1_link2}/g, json.benefit_1_link2 || "#")
      .replace(/{benefits1_link2_text}/g, json.benefit_1_link2_text)
      .replace(/{benefits1_link3}/g, json.benefit_1_link3 || "#")
      .replace(/{benefits1_link3_text}/g, json.benefit_1_link3_text)
      .replace(/{benefits2_title}/g, json.benefit_2_title)
      .replace(/{benefits2_description}/g, json.benefit_2_description)
      .replace(/{benefits2_link1}/g, json.benefit_2_link1 || "#")
      .replace(/{benefits2_link1_text}/g, json.benefit_2_link1_text)
      .replace(/{benefits2_link2}/g, json.benefit_2_link2 || "#")
      .replace(/{benefits2_link2_text}/g, json.benefit_2_link2_text)
      .replace(/{benefits2_link3}/g, json.benefit_2_link3 || "#")
      .replace(/{benefits2_link3_text}/g, json.benefit_2_link3_text)
      .replace(/{benefits3_title}/g, json.benefit_3_title)
      .replace(/{benefits3_description}/g, json.benefit_3_description)
      .replace(/{benefits3_link1}/g, json.benefit_3_link1 || "#")
      .replace(/{benefits3_link1_text}/g, json.benefit_3_link1_text)
      .replace(/{benefits3_link2}/g, json.benefit_3_link2 || "#")
      .replace(/{benefits3_link2_text}/g, json.benefit_3_link2_text)
      .replace(/{benefits3_link3}/g, json.benefit_3_link3 || "#")
      .replace(/{benefits3_link3_text}/g, json.benefit_3_link3_text);

    document.querySelectorAll(".benefits h3:empty").forEach((el) => {
      el.closest(".benefits").classList.add("hidden");
    });

    document
      .querySelectorAll(".sort-ingrendients__popin-close")
      .forEach((el) => {
        el.addEventListener("click", this.closePopin.bind(this));
      });

    this.popin_container.classList.add("opened");
    document.querySelector("body").classList.add("no-scroll");
  }

  closePopin() {
    this.popin_container.classList.remove("opened");
    document.querySelector("body").classList.remove("no-scroll");
  }
}

customElements.define("sort-ingredients", SortIngredients);
